module.exports = __webpack_public_path__ + "static/img/buy_evaluate_star@3x.bd2a5fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_evaluate_star@3x.png
// module id = r+AU
// module chunks = 1